import CheckboxField from 'components/CheckboxField';

type Props = {
  value: boolean;
  disabled?: boolean;
  error?: boolean;
  onChange: (value: boolean) => void;
};

const WorkOrderReasonSyncField = ({ value, disabled, error, onChange }: Props) => {
  return (
    <CheckboxField
      label="Sync notes with Work Order reason"
      helperText="When enabled, saving replaces the Work Order reason with these notes. The reason appears on invoices. Future edits sync both ways with other events that also have this option enabled."
      value={value}
      disabled={disabled}
      error={error}
      onChange={onChange}
      data-testid="sync_work_order_reason_field"
    />
  );
};

export default WorkOrderReasonSyncField;
